<template>
  <div class="c-categoryRatingSeo">
    <h2 class="c-categoryRatingSeo_title">
      <strong>{{ title }}</strong>
    </h2>
    <div
      v-for="(rating, index) in ratings"
      :key="`categoryRatingSeoRating${index}`"
      class="c-categoryRatingSeoRatings"
    >
      <div class="c-categoryRatingSeoRatingItem">
        <div class="c-categoryRatingSeoRatingItem_title c-ellipsisWithSuffix">
          <NuxtLink
            :to="addQueryToUrlIfBusinessPreview(`/services/${rating.serviceId}`)"
            class="c-ellipsisWithSuffix_body"
          >
            <div class="c-ellipsisWithSuffix_ellipsis">{{ rating.serviceName }}</div>
          </NuxtLink>
          <div class="c-ellipsisWithSuffix_suffix">の評価</div>
        </div>
        <div class="c-categoryRatingSeoRatingItem_date">
          {{ $util.dayjs.unix(rating.createdAt).format('YYYY-MM-DD H:mm:ss') }}
        </div>
        <div class="c-categoryRatingSeoRatingItemBody">
          <div class="c-categoryRatingSeoRatingItemBody_icon">
            <CUserIconV2
              :file-path="rating.userIconPath"
              :user-name="rating.userName"
              :size="40"
              v-if="!rating.isAnonymity"
            />
            <img
              class="c-userIcon c-userIcon-anonymous"
              src="@/assets/images/common/anonymous-person-f.png"
              alt="女性"
              loading="lazy"
              v-else-if="rating.userGender === sexFemale"
            />
            <img
              class="c-userIcon c-userIcon-anonymous"
              src="@/assets/images/common/anonymous-person-m.png"
              :alt="rating.userGender === sexMale ? '男性' : '匿名'"
              loading="lazy"
              v-else
            />
          </div>
          <div class="c-categoryRatingSeoRatingItemBody_content">
            <div class="c-categoryRatingSeoRatingItemBody_user">
              <div class="c-categoryRatingSeoRatingItemBody_rating">
                <CRatingStars
                  :size="14"
                  :score="rating.overallRate"
                />
              </div>
              <div class="c-categoryRatingSeoRatingItemBody_name">
                <span v-if="rating.isAnonymity">by {{ anonymousType(rating.userGender) }}</span>
                <span v-else>by {{ rating.userName }}</span>
              </div>
            </div>
            <div class="c-categoryRatingSeoRatingItemBody_comment">
              <div v-text="rating.comment"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const SEX_FEMALE = 'F'
const SEX_MALE = 'M'

import CRatingStars from '~/components/atoms/CRatingStars'

import businessMixin from '~/mixins/pages/business-mixin'

export default {
  name: 'CategoryRatingSeo',
  components: {
    CRatingStars
  },
  mixins: [businessMixin],
  props: {
    ratings: {
      type: Array,
      default: () => []
    },
    categoryName: {
      type: String,
      default: null
    },
    isTrendKeywordPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sexFemale: SEX_FEMALE,
      sexMale: SEX_MALE
    }
  },
  computed: {
    title() {
      if (this.isTrendKeywordPage && this.$route.query.keyword) {
        return `"${this.$route.query.keyword}"に関連するサービスの評価・感想`
      }
      return `${this.categoryName}の評価・感想`
    }
  },
  methods: {
    anonymousType(gender) {
      if (gender === SEX_FEMALE) {
        return '女性'
      } else if (gender === SEX_MALE) {
        return '男性'
      }
      return '匿名'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-categoryRatingSeo {
  margin-top: 40px;
  font-size: 13px;

  a {
    @include link-effect;
  }

  p {
    margin: 0;
  }

  &_title {
    margin-bottom: 8px;

    strong {
      color: $color-gray-900;
      font-size: 20px;
    }
  }
}

.c-categoryRatingSeoRatingItem {
  position: relative;
  padding: 16px 0;
  border-top: 1px solid $color-gray-200;

  &-folded {
    display: none;
  }

  &_title {
    padding: 0 0 12px;
    font-size: 13px;
    line-height: 21px;
  }

  &_date {
    position: absolute;
    top: 16px;
    right: 0;
    color: $color-gray-600;
    text-align: right;
    font-size: 10px;
    line-height: 21px;
  }
}

.c-categoryRatingSeoRatingItemBody {
  &_name {
    font-size: 12px;
  }

  &_comment {
    margin-top: 8px;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 14px;
    line-height: 21px;
  }
}

.c-userIcon {
  &-anonymous {
    max-width: 172px;
    max-height: 172px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.c-ellipsisWithSuffix {
  display: flex;
  overflow: hidden;

  flex-wrap: nowrap;

  &_body {
    @include link-effect;

    position: relative;
    display: inline-block;
    overflow: hidden;
    font-weight: bold;

    flex-shrink: 1;

    &::before {
      position: absolute;
      top: 0;
      content: '「';
    }

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      content: '」';
    }
  }

  &_ellipsis {
    display: inline-block;
    overflow: hidden;
    padding: 0 1em;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &_suffix {
    flex: 0 0 3em;
    width: 3em;
    font-weight: bold;
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-categoryRatingSeo {
    margin-right: 12px;
    margin-left: 12px;

    &_title {
      strong {
        font-size: 16px;
      }
    }
  }

  .c-categoryRatingSeoRatingItem {
    &_title {
      overflow: hidden;
      padding-bottom: 16px;
      height: 37px;
      font-size: 14px;
    }

    &_date {
      position: absolute;
      top: 53px;
      right: 0;
      color: $color-gray-600;
      text-align: right;
      font-size: 10px;
      line-height: 21px;
    }
  }

  .c-categoryRatingSeoRatingItemBody {
    position: relative;

    &_icon {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      width: 40px;
      height: 40px;
    }

    &_user {
      overflow: hidden;
      margin-left: 56px;
      height: 40px;
    }
  }
}

@media (min-width: breakpoint(Search, M) + 1) {
  .c-categoryRatingSeo {
    &_title {
      strong {
        font-size: 20px;
      }
    }
  }

  .c-categoryRatingSeoRatingItem {
    &_title {
      margin-right: 120px;
    }
  }

  .c-categoryRatingSeoRatingItemBody {
    display: flex;

    &_icon {
      flex: 0 0 40px;
      overflow: hidden;
      margin-right: 16px;
      width: 40px;
      height: 40px;
    }

    &_content {
      flex: 1;
    }

    &_user {
      display: flex;
    }

    &_rating {
      margin-right: 8px;
    }

    &_name {
      line-height: 16px;
    }
  }
}
</style>
